<ng-template #viewSummaryClient>
	<div class="personal-information">
		<div *ngIf="loading$ | async" class="summary-loading-overlay">
			<app-loading mode="spinner" [active]="true"></app-loading>
		</div>
		<div class="grid gutter-ux">
			<div class="lg:col-12 md:col-12 sm:col-12 col-12">
				<div class="container-row">
					<span class="title">{{ translations['summary'] }}</span>
				</div>
			</div>
		</div>

		<div class="grid gutter-ux">
			<div class="lg:col-12 md:col-12 sm:col-12 col-12 py-0">
				<div class="container-row">
					<div class="section-divider">
						<div class="divider"></div>
					</div>
				</div>
			</div>
		</div>

		<div class="grid gutter-ux">
			<div class="lg:col-12 md:col-12 sm:col-12 col-12">
				<div class="content">
					<div class="subtitle">Your information</div>
					<div>
						<span class="header">Name:</span>
						<span>{{ attributeClient('firstName') | async }} {{ attributeClient('lastName') | async }}</span>
					</div>
					<div>
						<span class="header">Email:</span>
						<span>{{ attributeClient('email') | async }}</span>
					</div>
					<div>
						<span class="header">Phone:</span>
						<span>{{ attributeClient('phone') | async }}</span>
					</div>
				</div>
			</div>
		</div>

		<div class="grid gutter-ux">
			<div class="lg:col-12 md:col-12 sm:col-12 col-12 py-0">
				<div class="container-row">
					<div class="section-divider">
						<div class="divider"></div>
					</div>
				</div>
			</div>
		</div>

		<div class="grid gutter-ux">
			<div class="lg:col-12 md:col-12 sm:col-12 col-12">
				<div class="content">
					<div class="subtitle">{{ translations['paymentMethod'] }}</div>
					<div>
						<span class="header">Payment method: </span>
						<span>{{ paymentMethod() | async }}</span>
					</div>
					<div>
						<span class="header">Tip: </span>
						<span>{{ attributeCartTotals('tip') | async | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}</span>
					</div>
					<div>
						<span class="header">Coupon: </span>
						<span>{{ attributeCartTotals('couponDiscount') | async | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}</span>
					</div>
				</div>
			</div>
		</div>

		<!-- <div class="client-info">
			<div class="client-details gap-4">
				<div class="user-info-container">
					<span class="subtitle">
						{{ attributeClient('firstName') | async }} {{ attributeClient('lastName') | async }}
					</span>
					<span class="subtitle">
						{{ attributeClient('email') | async }}
					</span>
					<span class="subtitle">
						{{ attributeClient('phone') | async }}
					</span>
				</div>
			</div>
		</div> -->
	</div>
</ng-template>

<ng-template #viewSummary>
	<div class="cart-section-summary">
		<div *ngIf="loading$ | async" class="summary-loading-overlay">
			<app-loading mode="spinner" [active]="true"></app-loading>
		</div>
		<div class="cart-section-content" *ngIf="cartTotals$ | async as totals">
			<div class="grid gutter-ux w-100">
				<div class="lg:col-12 md:col-12 sm:col-12 col-12 p-0">
					<div class="container-row">
						<div class="cart-section-item promo-section">
							<div class="personal-info-header">
								<span class="font-weight-bold">{{ translations['promos'] }}</span>
							</div>
							<div *ngIf="!showPromoInput" class="promo-link p-0" (click)="togglePromoInput()">
								<span class="promo-text">
									{{ appliedCoupon ? translations['removePromoCode'] : translations['havePromoCode'] }}
								</span>
							</div>

							<div *ngIf="showPromoInput" class="promo-container">
								<app-input
									id="promoCode"
									type="text"
									controlId="promoCode"
									[ngClass]="{ 'applied-coupon': !!appliedCoupon }"
									[ngModel]="appliedCoupon || promoCode"
									[ngModelOptions]="{ standalone: true }"
									[readonly]="!!appliedCoupon"
									[placeholder]="translations['promoCode']"
									(ngModelChange)="onPromoCodeChange($event)"
								/>

								<button
									type="button"
									class="btn-apply-promo"
									[class.btn-remove-promo]="!!appliedCoupon"
									(click)="handlePromoAction()"
								>
									<div class="h-full flex flex-row gap-2 text-center">
										<app-loading
											mode="spinner"
											[active]="(loading$ | async) ?? false"
											class="button-spinner"
										></app-loading>
										<span *ngIf="!(loading$ | async)">
											{{ appliedCoupon ? translations['remove'] : translations['apply'] }}
										</span>
									</div>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="cart-section-item text-center summary-row">
				<span class="title-summary-row">{{ translations['subtotal'] }}</span>
				<span class="font-weight-bold">
					{{ totals.subtotal | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}
				</span>
			</div>

			<div class="cart-section-item text-center summary-row" *ngIf="totals.tip">
				<span class="title-summary-row">{{ translations['tip'] }}</span>
				<span class="font-weight-bold text-danger">
					+{{ totals.tip | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}
				</span>
			</div>

			<div class="cart-section-item text-center summary-row" *ngIf="totals.couponDiscount">
				<span class="title-summary-row">{{ translations['couponDiscount'] }}</span>
				<span class="font-weight-bold text-success">
					-{{ totals.couponDiscount | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}
				</span>
			</div>

			<div class="cart-section-item text-center summary-row" *ngIf="(serviceType$ | async) === 'Delivery'">
				<span class="title-summary-row">{{ translations['deliveryCharges'] }}</span>
				<span class="font-weight-bold text-danger">
					+{{ (totals.deliveryCharges | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision) ?? 0 }}
				</span>
			</div>

			<div *ngIf="totals.taxes" class="cart-section-item text-center summary-row">
				<span class="title-summary-row">{{ translations['tax'] }}</span>
				<span class="font-weight-bold text-danger">
					+{{ totals.taxes | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}
				</span>
			</div>

			<div *ngIf="totals.totalCash" class="cart-section-item text-center summary-row">
				<span class="title-summary-row">{{ 'Total With Cash' }}</span>
				<span class="font-weight-bold text-danger">
					{{ totals.totalCash | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}
				</span>
			</div>

			<div
				*ngIf="!isCart"
				class="cart-section-item order-total flex justify-content-between summary-row align-items-center"
			>
				<div class="flex align-items-center gap-2" style="color: var(--ion-color-secondary)">
					<span class="title-summary-row font-weight-bold color-[#3D487E]">{{ translations['total'] }}</span>
				</div>
				<span class="font-weight-bold">
					{{ totals.total | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}
				</span>
			</div>

			<div *ngIf="isCart" class="w-full">
				<app-button-action
					(buttonClick)="onProcedCheckout()"
					[disabled]="existProductOutStock.length > 0"
					icon="cart-outline"
					[text]="translations['goToPay']"
					textRight="{{ totals.total | integerToFloat | currency: 'USD' : 'symbol' : decimalPrecision }}"
				/>
			</div>
		</div>
	</div>
</ng-template>

<div *ngIf="overrideCardContainer; else elseWithCard">
	<ng-container *ngTemplateOutlet="viewSummary"></ng-container>
</div>

<ng-template #elseWithCard>
	@if (showUserSummary) {
		<div class="card">
			<div class="card-content">
				<ng-container *ngTemplateOutlet="viewSummaryClient" />
			</div>
		</div>
	} @else {
		<ng-container *ngTemplateOutlet="viewSummary" />
	}
</ng-template>
